import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { TIER_DEFAULTS, coefficient, formatCoefficient } from '../utils/raceFormat';

const filled = (v) => v !== '' && v !== null && v !== undefined;

// The three placing-tier rows (level label / position / bird count) shared by
// the bird profile's result dialog and the season chart's cell dialog — both
// edit the same race_results row shape, so the fields and their constraints
// must never diverge.

export const emptyTierForm = (labels = TIER_DEFAULTS) => ({
  t1_label: labels[0] || TIER_DEFAULTS[0], t1_pos: '', t1_birds: '',
  t2_label: labels[1] || TIER_DEFAULTS[1], t2_pos: '', t2_birds: '',
  t3_label: labels[2] || TIER_DEFAULTS[2], t3_pos: '', t3_birds: ''
});

export const resultToTierForm = (r) => ({
  t1_label: r.t1_label ?? TIER_DEFAULTS[0], t1_pos: r.t1_pos ?? '', t1_birds: r.t1_birds ?? '',
  t2_label: r.t2_label ?? TIER_DEFAULTS[1], t2_pos: r.t2_pos ?? '', t2_birds: r.t2_birds ?? '',
  t3_label: r.t3_label ?? TIER_DEFAULTS[2], t3_pos: r.t3_pos ?? '', t3_birds: r.t3_birds ?? ''
});

// form: object holding tN_label/tN_pos/tN_birds keys (may hold more).
// onField: (fieldName) => changeHandler
const TierPlacingFields = ({ form, onField }) => (
  <>
    {[1, 2, 3].map((n) => {
      const labelKey = `t${n}_label`, posKey = `t${n}_pos`, birdsKey = `t${n}_birds`;
      const hasPos = filled(form[posKey]);
      const hasBirds = filled(form[birdsKey]);
      const coeff = coefficient(form[posKey], form[birdsKey]);
      return (
        <Grid container spacing={1} key={n} alignItems="center">
          <Grid item xs={12} sm={4}>
            <TextField
              label={`Level ${n}`}
              value={form[labelKey]}
              onChange={onField(labelKey)}
              size="small"
              fullWidth
              placeholder={TIER_DEFAULTS[n - 1]}
              inputProps={{ maxLength: 120 }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              label="Position"
              value={form[posKey]}
              onChange={onField(posKey)}
              size="small"
              fullWidth
              type="number"
              inputProps={{ min: 1 }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              label="Out of (birds)"
              value={form[birdsKey]}
              onChange={onField(birdsKey)}
              size="small"
              fullWidth
              type="number"
              inputProps={{ min: 1 }}
            />
          </Grid>
          {(hasPos || hasBirds) && (
            <Grid item xs={12} sx={{ pt: '2px !important', mt: -0.5 }}>
              <Typography
                variant="caption"
                color={coeff !== null ? 'text.secondary' : 'warning.main'}
              >
                {coeff !== null
                  ? `Coefficient ${formatCoefficient(coeff)}`
                  : hasPos
                    ? 'Enter the field size (birds) to get a coefficient.'
                    : 'Enter the finishing position to get a coefficient.'}
              </Typography>
            </Grid>
          )}
        </Grid>
      );
    })}
    <Typography variant="caption" color="text.secondary">
      Coefficient = position × 1000 ÷ birds basketed (capped at 5000), per FCI World Best
      Pigeon rules — lower is better. &ldquo;Out of&rdquo; should be the total birds sent to
      the race, not just the prize winners on the result sheet, and without it no
      coefficient can be calculated.
    </Typography>
  </>
);

export default TierPlacingFields;
